import React, { useState, useEffect } from "react";
import { PAGE_LIMIT } from "../../constants/text_constants";
import { stripHtml } from "../../utils/util-functions/stripHTML";
import { stripText } from "../../utils/util-functions/stripText";
import { formatDate } from "../../utils/util-functions/formatDate";
import CALENDER_ICON from "../../assets/CalendarBlank.png";
import CLOCK_ICON from "../../assets/Clock.png";
import { useNavigate } from "react-router-dom";
import { ScrollArea } from "../../components/ui/scroll-area";
import userLogout from "../../utils/userLogout";
import { useDispatch } from "react-redux";
import StarRating from "../Star-Component/StarRating";
import Pagination from "../Pagination/Pagination";

const SuggestedVideos = ({ id, subjectid, clickUrl }) => {
  const [suggestedVideosData, setSuggestedVideosData] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchSuggestedVideos = async (retries = 6) => {
    try {
      const authToken = sessionStorage.getItem("token");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      };
      const response = await fetch(
        process.env.REACT_APP_RANK_PLUS_CLASSROOM_SUGGESTED_VIDEOS +
          `lecture_id=${id}&subject_id=${subjectid}&limit=200&page=${0}`,
        requestOptions
      );
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) {
          userLogout(navigate, dispatch, true);
        }
        if (response.status >= 500 && response.status < 600 && retries > 0) {
          console.warn(`Retrying... attempts left: ${retries}`);
          setTimeout(() => fetchSuggestedVideos(retries - 1), 10000);
          return;
        } else {
          throw new Error(`HTTP error: ${response.status}`);
        }
      }
      const json = await response.json();
      setSuggestedVideosData(json?.data);
    } catch (err) {
      console.error("Error fetchSuggestedVideos", err);
    }
  };

  useEffect(() => {
    fetchSuggestedVideos();
  }, [id, subjectid]);

  function handleClick(id, subject_id = "") {
    if (subject_id === "") {
      navigate(clickUrl + `/${id}`);
    } else {
      navigate(clickUrl + `/${id}/${subject_id}`);
    }
  }

  return (
    <div style={{ fontFamily: "DM Sans" }}>
      <div className="md:text-2xl text-xl mb-5">Related Videos</div>
      <ScrollArea className="
   md:w-[26rem]
    w-full
    h-[70vh]
-   p-4
    border border-[#DFE3EC]
    rounded-2xl
    mt-2
    shadow-xl
    
  ">
    <div className="p-4 pb-20">
        {suggestedVideosData?.lectures?.map((ele, i) => (
       <div
  key={i}
  onClick={() => handleClick(ele?.id, ele?.subject_id)}
  className="
    my-3 bg-[#F8FCFD] border border-[#DFE3EC]
    rounded-lg p-3
    shadow-sm cursor-pointer
    flex items-center gap-3
  "
>
  {/* Thumbnail */}
  <img
    src={ele?.thumbnail}
    alt={ele?.id}
    loading="lazy"
    className="
      w-[76px] h-[52px]
      lg:w-[8rem] lg:h-auto
      rounded-lg object-cover
      flex-shrink-0
    "
  />

  {/* Content */}
  <div className="flex-1 min-w-0">
    {/* Title */}
    <div className="font-semibold text-xs lg:text-sm line-clamp-1">
      {ele?.title}
    </div>

    {/* Rating */}
    <div className="flex items-center gap-2 mt-0.5">
      <StarRating rating={Math.floor(ele?.rating)} />
      <div className="italic text-[10px] lg:text-sm text-gray-500">
        ({ele?.total_rating} ratings)
      </div>
    </div>

    {/* Meta Info */}
    <div className="flex items-center gap-3 text-[10px] lg:text-sm text-gray-500 mt-1">
      <div className="flex items-center gap-1">
        <img src={CALENDER_ICON} className="w-3 h-3" />
        {formatDate(ele?.created_at)}
      </div>
      <div className="flex items-center gap-1">
        <img src={CLOCK_ICON} className="w-3 h-3" />
        {ele?.video_length}
      </div>
    </div>
  </div>
</div>

        ))}
        </div>
      </ScrollArea>
    </div>
  );
};

export default SuggestedVideos;
